import { Button, DialogActions, DialogTitle } from "@material-ui/core";
import React from "react";
import styled from "styled-components";

import {
    WorkspaceUserRole
} from "common/interfaces";
import WorkspaceController, {
    WorkspaceControllerState
} from "js/controllers/WorkspaceController";
import getLogger from "js/core/logger";
import { UserProfile } from "js/react/components/Avatar";
import {
    BeautifulDialog,
    DialogContent
} from "js/react/components/Dialogs/BaseDialog";

const logger = getLogger();

const FlexDiv = styled.div`
    display: flex;
`;

const SpacedPTag = styled.p`
    letter-spacing: .1px;
`;

const ProfileContainer = styled.div`
    display: flex;
    padding: 10px;
`;

const OwnersAndLibrariansProfilesContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    overflow-y: auto;
`;

const StyledDialogTitle = styled(DialogTitle)`
    &&& {
        padding: 34px 34px 0;
    }
`;

const StyledDialogContent = styled(DialogContent)`
    &&& {
        padding: 0 34px 0;
    }
`;

export interface MissingManageTeamFolderPermissionsDialogProps {
    folderId: string;
    closeDialog: () => void;
}

export const MissingManageTeamFolderPermissionsDialog = WorkspaceController.withInitializedState(
    function MissingManageTeamFolderPermissionsDialog(props: MissingManageTeamFolderPermissionsDialogProps & WorkspaceControllerState) {
        const { closeDialog, users, userGroups, resourceFolders, folderId } = props;

        const folder = resourceFolders.find(f => f.id === folderId);
        if (!folder) {
            throw new Error("Folder not found");
        }

        const usersWithAccess = WorkspaceController.getUsersWithAccessToResourceFolder(folderId);
        const ownersWithAccess = usersWithAccess.filter(user => user.role === WorkspaceUserRole.OWNER);

        return (
            <BeautifulDialog closeDialog={closeDialog}>
                <StyledDialogTitle>Sorry, you don't have permission to manage folder access.</StyledDialogTitle>
                <StyledDialogContent>
                    <SpacedPTag>This folder's settings only allow folder owners to update folder access. You can reach out to the following team members for help:</SpacedPTag>
                    <FlexDiv>
                        <OwnersAndLibrariansProfilesContainer>
                            {ownersWithAccess.map(user => {
                                return (
                                    <ProfileContainer key={user.uid}>
                                        <UserProfile profile={user} />
                                    </ProfileContainer>
                                );
                            })}
                        </OwnersAndLibrariansProfilesContainer>
                    </FlexDiv>
                </StyledDialogContent>
                <DialogActions>
                    <Button color="primary" onClick={closeDialog} >
                        Got It
                    </Button>
                </DialogActions>
            </BeautifulDialog>
        );
    }
);
